module.exports = __webpack_public_path__ + "static/hr_capabilities_11-60cd74a8f0d6810d9fab482bf93909e0.png";